"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { BatchDataProvider } from "@/lib/batch-data-context"
import { usePuckBatchData } from "@/lib/usePuckBatchData"
import { getSiteIdFromHost } from "@/sites/config"
import { useDomainStore } from "@/stores/use-domain-store"
import { Render } from "@measured/puck"
import { Button } from "antd"
import Spin from "antd/es/spin"
import AOS from "aos"
import "aos/dist/aos.css"
import { useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"
import { t } from "../../../../languages/i18n"
import "../config/styles.css"
import { uiBuilderConfig } from "../config/uiBuilderConfig"
import { useUiBuilder } from "../services/ui-builder"

export function Preview() {
  const { fetchBlockContent } = useUiBuilder()
  const searchParams = useSearchParams()
  const id = searchParams.get("id")
  const [data, setData] = useState<unknown>(null)
  const selectedDomain = useDomainStore(state => state.selectedDomain)
  const selectedDomainName = selectedDomain?.id ? selectedDomain.attributes?.domain?.trim().toLowerCase() : ""
  const host = typeof window !== "undefined" ? window.location.host : ""
  const siteId = selectedDomainName
    ? selectedDomainName === "tamdamedia.eu"
      ? "tamdamedia.eu"
      : "tamdagroup.eu"
    : getSiteIdFromHost(host)

  const locale = useUIBuilderLocaleStore(state => state.locale)
  const { batchData } = usePuckBatchData(data, {
    locale,
    siteId
  })


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchBlockContent(id!)

        const content = response?.data.attributes.content
          ? (() => {
              if (typeof response?.data.attributes.content === "string") {
                return JSON.parse(response?.data.attributes.content)
              } else if (typeof response?.data.attributes.content === "object") {
                return response?.data.attributes.content
              }
              return undefined
            })()
          : undefined
        const blockLocale = response?.data?.attributes?.locale
        if (blockLocale) {
          useUIBuilderLocaleStore.getState().setLocale(blockLocale)
        }
        setData(content)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }

    fetchData()
    AOS.init()
  }, [])

  if (!data) {
    return <Spin />
  }

  return (
    <>
      <nav
        style={{
          backgroundColor: "white",
          padding: "10px",
          borderBottom: "1px solid #ddd",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          textAlign: "right",
          display: "flex",
          justifyContent: "space-between",
          position: "fixed",
          zIndex: 500,
          width: "100%",
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        <Button className="uppercase text-xs font-bold" onClick={() => (window.location.href = `/admin`)}>
          {t("Back to Home")}
        </Button>
        <Button
          type="primary"
          className="uppercase text-xs font-bold"
          onClick={() => (window.location.href = `/admin/ui-builder?id=${id}`)}
        >
          {t("Edit with UI Builder")}
        </Button>
      </nav>

      <BatchDataProvider data={batchData}>
        <Render config={uiBuilderConfig} data={data} />
      </BatchDataProvider>
    </>
  )
}
